module.exports = __webpack_public_path__ + "img/yggl.c060aa4b.png";